module.exports = __webpack_public_path__ + "media/images/landing_page/screen_pc-35bfe3d19826a556d893fb958d7d94f6.webp";